import React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { updateBackLink, updateProgress } from '../../index';

class StepShell extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            animation: 'SlideIn'
        }
    }

    componentDidMount() {
        var progress = this.props.progress;
        var progLabel = this.props.progressLabel ? this.props.progressLabel : "unknown step";
        var backLink = this.props.backLink;
        updateProgress(progress, progLabel);
        updateBackLink(backLink);
    }

    // See React Doc regarding how to use animation https://reactjs.org/docs/animation.html#animate-initial-mounting
    render() {
        let reqText;
        // var url = window.location.href;
        if(this.props.requestText !== "") {
            reqText = (
                <div className="step-request-text">{this.props.requestText}</div>
            );
        }else{
            reqText = "";
        }
        return (
            <CSSTransitionGroup
                transitionAppear={true}
                transitionAppearTimeout={600}
                transitionEnterTimeout={600}
                transitionLeaveTimeout={200}
                transitionName={this.state.animation}
            >
                <div id={this.props.stepID} className={`loanApp-step ${this.props.stepID}`}>
                    <div className="step-friendly-text">{this.props.friendlyText}</div>
                    <div className="step-wrap">
                        {reqText}
                        {this.props.children}
                    </div>
                </div>
            </CSSTransitionGroup>
        )
    }
}

export default StepShell;